import { Link } from "react-router-dom";

import { Blockquote } from "../components/Blockquote";
import { Border } from "../components/Border";
import { Button } from "../components/Button";
import { ContactSection } from "../components/ContactSection";
import { Container } from "../components/Container";
import { FadeIn, FadeInStagger } from "../components/FadeIn";
import { PageIntro } from "../components/PageIntro";
import { Testimonial } from "../components/Testimonial";
import logoBrightPath from "../images/clients/bright-path/logo-dark.svg";
import logoFamilyFund from "../images/clients/family-fund/logo-dark.svg";
import logoGreenLife from "../images/clients/green-life/logo-dark.svg";
import logoHomeWork from "../images/clients/home-work/logo-dark.svg";
import logoMailSmirk from "../images/clients/mail-smirk/logo-dark.svg";
import logoNorthAdventures from "../images/clients/north-adventures/logo-dark.svg";
import logoPhobia from "../images/clients/phobia/logo-dark.svg";
import logoUnseal from "../images/clients/unseal/logo-dark.svg";
import { formatDate } from "../lib/formatDate";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { TagList, TagListItem } from "../components/TagList";
const works = [
  {
    client: "DergiPark",
    title: "The biggest platform for digital content in Türkiye.",
    description:
      "It is a leading platform for academic publications and digital archiving solutions, providing a comprehensive digital library for researchers, academics, and publishers.",
      summary: [
        "Under the umbrella of TÜBİTAK ULAKBİM, DergiPark provides hosting and editorial process management services in electronic format for academic peer-reviewed journals published in Turkey. ",
        "DergiPark provides infrastructure and technical support for the use of the system. Authors should contact the editor and publisher of the relevant journal for all matters regarding their publications.",
      ],
    logoImage: {
      src: "https://dergipark.org.tr/zollu/images/dergipark_header.png",
    },
    image: { src: "imageHero" },
    date: "2014-01",
    class: "AI and Software",
    service: "AI and Information",
    testimonial: {
      author: { name: "Debra Fiscal", role: "CEO of FamilyFund" },
      content:
        "Working with Studio, we felt more like a partner than a customer. They really resonated with our mission to change the way people convince their parents to cash out their pensions.",
    },
    href: "/works",
    website: "https://dergipark.org.tr/",
    keywords: ["Large Language Model","Decision-making", "Machine Learning", "Data Insights","Predictive Analytics"],
  },
  {
    client: "Suyabakan",
    title: "AI and IoT powered smart agriculture technologies.",
    description:
      "Akıllı cihazlar ve yazılım entegrasyonu sayesinde tarım sektöründe çözümler üretiyor, geniş ürün yelpazesi ve güçlü yazılımlarımız sayesinde bir çok kategoride etkinlik göstermekteyiz",
    summary: [
      "Suyabakan delivers innovative agricultural solutions powered by artificial intelligence and IoT technology.",
      " We offer a comprehensive suite of services, including irrigation system automation, soil moisture sensors, farm management software, and satellite imagery solutions, encompassing both software and hardware components.",
    ],
    logo: "",
    logoImage: {
      src: "https://cdn.dribbble.com/userupload/5065657/file/original-cd9cb73b18d84318f46043cec60030c1.png?resize=752x593&vertical=center",
    },
    image: { src: "imageHero" },
    date: "2022-10",
    class: "Hardware, AI and Software",
    service: "Smart Agriculture",
    testimonial: {
      author: { name: "Emily Selman", role: "Head of Engineering at Unseal" },
      content:
        "Studio did an amazing job building out our core blockchain infrastructure and I’m sure once PlaceboCoin rallies they’ll be able to finish the project.",
    },
    href: "/works",
    website: "http://suyabakan.com/",
    keywords: ["Machine Learning","IoT", "Sensors", "Automated Systems" , "Real-time Data", "Data Insights"],

  },
  {
    client: "Sentinen",
    title: "Utility solutions using AI, hardware and software.",
    description:
      "We provide solutions to many issues in the electricity distribution sector, develop projects, and deliver products at the end of those projects.",
    summary: [
      "At Sentinen, we specialize in developing advanced hardware and software solutions for next-generation public utilities. Our mission is to improve energy distribution systems through innovative engineering, ensuring reliability, efficiency, and sustainability.",
      "Pioneering the future of public services, we provide solutions for energy sector which are high performance and user friendly.",
    ],
    logoImage: {
      src: "https://cdn.dribbble.com/userupload/10378002/file/original-0e71eef6b2f8eb7fd15fd3da9ce19467.png?resize=2048x1664&vertical=center",
    },
    image: { src: "imageHero" },
    date: "2022-06",
    class: "Hardware and Software",
    service: "NextGen Utility",
    testimonial: {
      author: { name: "Jenny Wilson", role: "CPO of Phobia" },
      content:
        "The team at Studio went above and beyond with our onboarding, even finding a way to access the user’s microphone without triggering one of those annoying permission dialogs.",
    },
    href: "/works",
    website: "http://sentinen.com/",
    keywords: ["Machine Learning", "Resource Optimization" ,"IoT", "Automation", "Real-time Monitoring"],

  },
];

const clients = [
  ["Family Fund", logoFamilyFund],
  ["Unseal", logoUnseal],
  ["Mail Smirk", logoMailSmirk],
  ["Home Work", logoHomeWork],
  ["Green Life", logoGreenLife],
  ["Bright Path", logoBrightPath],
  ["North Adventures", logoNorthAdventures],
];
function CaseStudies() {
  const location = useLocation();

  useEffect(() => {
    const { hash } = location;
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }else{
      window.scrollTo(0, 0);
    }

  }, [location]);
  // window.scrollTo(0, 0);

  return (
    <Container className="mt-40">
      <FadeIn>
        <h2 className="font-display text-2xl font-semibold text-neutral-950">
          Our brands
        </h2>
      </FadeIn>
      <div className="mt-10 space-y-20 sm:space-y-24 lg:space-y-32">
        {works.map((work) => (
          <FadeIn id={work.client} key={work.client}>
            <article>
              <Border className="grid grid-cols-3 gap-x-8 gap-y-8 pt-16">
                <div className="col-span-full  lg:col-span-1 lg:block">
                  <div className="sm:flex sm:items-center sm:gap-x-6 lg:block">
                    <img
                      src={work.logoImage.src}
                      alt=""
                      className={
                        work.service == "Bilgi Sistemleri"
                          ? "my-5 h-14"
                          : "h-24 " + " w-auto flex-none"
                      }
                      unoptimized
                    />
                  </div>
                  <div className="mt-1 flex gap-x-4 sm:mt-0 lg:block">
                    <h3 className=" text-sm font-semibold tracking-tight text-neutral-950 after:ml-4 after:font-semibold after:text-neutral-300 after:content-['/'] lg:mt-2 lg:after:hidden">
                      {work.client}
                    </h3>
                    <p className="text-sm tracking-tight text-neutral-950 after:ml-4 after:font-semibold after:text-neutral-300 after:content-['/'] lg:mt-2 lg:after:hidden">
                      {work.service}
                    </p>
                    <p className="text-sm text-neutral-950 lg:mt-2">
                      <time dateTime={work.date}>{formatDate(work.date)}</time>
                    </p>
                  </div>
                  <div className="lg:mt-4 ">
                    <h3 className="mt-2 font-display text-base font-semibold text-neutral-950">
                      Included in this brand
                    </h3>
                    <TagList className="mt-2">
                      {work.keywords.map((keyword) => ( 
                         <TagListItem key={keyword}>{keyword}</TagListItem>  
                      ))
                      }
                    </TagList>
                  </div>
                </div>
                <div className="col-span-full lg:col-span-2 lg:max-w-2xl">
                  <p className="font-display text-4xl font-medium text-neutral-950">
                    <Link href={work.href}>{work.title}</Link>
                  </p>
                  <div className="mt-6 space-y-6 text-base text-neutral-600">
                    {work.summary.map((paragraph) => (
                      <p key={paragraph}>{paragraph}</p>
                    ))}
                  </div>
                  <div className="mt-8 flex dark-section">
                    <Button
                      href={work.website}
                      aria-label={`Read case study: ${work.client}`}
                    >
                      Explore the Website
                    </Button>
                  </div>
                  {/* {work.testimonial && (
                    <Blockquote
                      author={work.testimonial.author}
                      className="mt-12"
                    >
                      {work.testimonial.content}
                    </Blockquote>
                  )} */}
                </div>
              </Border>
            </article>
          </FadeIn>
        ))}
      </div>
    </Container>
  );
}

function Clients() {
  return (
    <Container className="mt-24 sm:mt-32 lg:mt-40">
      <FadeIn>
        <h2 className="font-display text-2xl font-semibold text-neutral-950">
          You’re in good company
        </h2>
      </FadeIn>
      <FadeInStagger className="mt-10" faster>
        <Border as={FadeIn} />
        <ul
          role="list"
          className="grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-3 lg:grid-cols-4"
        >
          {clients.map(([client, logo]) => (
            <li key={client} className="group">
              <FadeIn className="overflow-hidden">
                <Border className="pt-12 group-[&:nth-child(-n+2)]:-mt-px sm:group-[&:nth-child(3)]:-mt-px lg:group-[&:nth-child(4)]:-mt-px">
                  <img src={logo} alt={client} unoptimized />
                </Border>
              </FadeIn>
            </li>
          ))}
        </ul>
      </FadeInStagger>
    </Container>
  );
}

export default function Work() {
  return (
    <>
      <PageIntro title="Proven solutions to real-world problems.">
        <p>
          We believe in delivering the best value to our customers by maximizing
          efficiency and utilizing our resources in the best possible way. The
          best way to do this, however, is by having a cup of coffee.
        </p>
      </PageIntro>

      <CaseStudies />

      <Testimonial
        className="mt-24 sm:mt-32 lg:mt-40"
        client={{ name: clients[0][0], logo: logoFamilyFund }}
      >
        We approached <em>YT</em> because we loved their past work. They
        delivered something remarkably similar in record time.
      </Testimonial>

      {/* <Clients /> */}

      <ContactSection />
    </>
  );
}
